import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const compare = (path: string, refPath: string): ValidatorFn => {
  return (form: AbstractControl): ValidationErrors | null => {
    const control = form.get(path);
    const refControl = form.get(refPath);

    if (control && refControl && control.value !== refControl.value) {
      setControlError(control);
      return { compare: true };
    } else if (control) {
      unsetControlError(control);
      return null;
    } else {
      return null;
    }
  };
};

const setControlError = (control: AbstractControl): void => {
  const errors = control.errors || {};
  control.setErrors({ ...errors, compare: true });
};

const unsetControlError = (control: AbstractControl): void => {
  const errors = control.errors || {};
  const newErrorKeys = Object.keys(errors).filter(k => k !== 'compare');

  if (newErrorKeys.length > 0) {
    const newErrors = newErrorKeys.reduce((err, k) => ({ ...err, [k]: errors[k] }), {} as ValidationErrors);
    control.setErrors(newErrors);
  } else {
    control.setErrors(null);
  }
};
